import React from "react";
import { AxiosError } from "axios";
export function errorHandler(err: AxiosError) {
  if (err.response) {
    console.log(err.response);
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    // console.log(err.response.data);
    // console.log(err.response.status);
    // console.log(err.response.headers);
  } else if (err.request) {
    // The request was made but no response was received
    // `err.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    // console.log(err.request);
  } else {
    // Something happened in setting up the request that triggered an err
    // console.log('err', err.message);
  }
  throw err;
}

const MONTH_FULL = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

/* "4 July, 2026 10:30:02 PM" */
export function formatDateTime(date: any): string {
  if (!date) return "-";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "-";
  const pad = (n: number) => String(n).padStart(2, "0");
  let h = d.getHours();
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${d.getDate()} ${MONTH_FULL[d.getMonth()]}, ${d.getFullYear()} ${h}:${pad(d.getMinutes())}:${pad(d.getSeconds())} ${ampm}`;
}

/* Renders "**text**" as bold, stripping the asterisks. Everything else is left as-is. */
export function renderFormattedText(text: string | null | undefined): React.ReactNode {
  if (!text) return "-";
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**") && part.length > 4) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}
